module.exports = __webpack_public_path__ + "img/icon_005.af58db3.webp";